export const snapShotExtentionMapper = (resp) => {
    if (resp) {
        return resp.map((val) => {
            return {
                chequeNo: val.chequeNo,
                cummulativeBalance: val.cummulativeBalance,
                date: val.date,
                dateFormate: val.cummulativeBalance,
                dueDate: val.dueDate,
                exchange: val.exchange,
                ledgerKey: val.ledgerKey,
                narration: val.narration,
                paymentsInRs: val.paymentsInRs,
                receiptsInRs: val.receiptsInRs,
                rowNumber: val.rowNumber,
                settlementNo: val.settlementNo,
                voucherType: val.voucherType,
            };
        });
    }
    return [];
};
